import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { IOperator } from 'app/models';
import { Constants } from '@config/constants';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class OperatorService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  findAll = (): Observable<IOperator[]> =>
    this.http
      .get<IOperator[]>(this.constants.OPERATOR_ENDPOINT)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  findAllByCustomer = (customerId: number): Observable<IOperator[]> =>
    this.http
      .get<IOperator[]>(`${this.constants.OPERATOR_ENDPOINT}?customerId=${customerId}`)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  add = (operator: Partial<IOperator>): Observable<IOperator> =>
    this.http
      .post<IOperator>(this.constants.OPERATOR_ENDPOINT, operator)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  update = (id: number, operator: Partial<IOperator>): Observable<IOperator> =>
    this.http
      .patch<IOperator>(`${this.constants.OPERATOR_ENDPOINT}/${id}`, operator)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  delete = (id: number): Observable<void> =>
    this.http
      .delete<void>(`${this.constants.OPERATOR_ENDPOINT}/${id}`)
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
